<template>
  <div class="faq-page">
    <!-- <mt-header title="活动咨询说明" class="nav-bar">
      <router-link to="/" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
      <img slot="right" src="../../assets/question-close-icon.png" alt="">
    </mt-header> -->
    <Top></Top>
    <div v-html="content" class="content"></div>
  </div>
</template>
<script>
import Api from '../../api/question'
import Top from '../common/top.vue'
export default {
  components: {
    Top
  },
  data() {
    return {
      content: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.$route.query.type == 'swipe') {
        this.getSwipe()
      } else {
        this.getType()
      }
    },
    // 轮播图
    getSwipe() {
      Api.getCrouselDetails({ visitorMd5Code: this.$route.query.v, id: this.$route.query.id }, res => {
        if (res.code === 1) {
          this.content = res.data.replyContent
        }
      })
    },
    // 问题类型
    getType() {
      Api.getTypeDetails({ visitorMd5Code: this.$route.query.v, id: this.$route.query.id }, res => {
        if (res.code === 1) {
          this.content = res.data.faq
        }
      })
    }
  }
}
</script>
<style>
.faq-page {
	height: 100%;
	padding-bottom: 50px;
	box-sizing: border-box;
	background: fixed url(/pc/static/assets/question-nav.png) no-repeat;
	background-size: 100% auto;
	background-color: #F8F9FC;
  overflow: auto;
}
.faq-page .nav-bar {
	color: #333;
	background-color: transparent;
}
.faq-page .nav-bar a {
	color: #333;
}
.faq-page .nav-bar .mint-header-title {
	color: #333;
}
.faq-page .nav-bar img {
	width: 20px;
	height: 20px;
}
.faq-page .content {
	padding: 15px 20px 50px 20px;
	font-size: 15px;
}
.faq-page .content div {
	font-size: 15px !important;
	text-wrap: wrap;
}
.faq-page .content p {
	font-size: 15px !important;
	text-wrap: wrap;
}
.faq-page .content span {
	font-size: 15px !important;
	text-wrap: wrap;
}
.faq-page .content img {
	max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/question/faqPage.vue?07a5d856